<template>
    <div>
        <div class="com-model">
            <div class="title">充值方式</div>
            <div class="type-list flex flex-wrap " style="margin-bottom: 60px">
                <div @click="selPayway('alipay')" class="type-item flex flex-center" :class="{active:payway == 'alipay'}">
                    <img style="width: 44px; height:44px;margin-right: 16px" src="../../assets/images/zhifubao_icon.png" />
                    <i class="el-icon-check"></i>
                    支付宝
                </div>
                <div @click="selPayway('wxpay')"  class="type-item flex flex-center" :class="{active:payway == 'wxpay'}">
                    <img style="width: 44px; height:44px;margin-right: 16px" src="../../assets/images/weixin_icon.png" />
                    <i class="el-icon-check"></i>
                    微信
                </div>
            </div>
            <div class="title">充值数量</div>
            <div class="flex flex-wrap" style="margin-bottom: 15px">
                <div :class="{active:money==50 && customRadio != 1}" class="num-item" @click="selMoney(50)"><i class="el-icon-check"></i>50平台币</div>
                <div :class="{active:money==100 && customRadio != 1}" class="num-item" @click="selMoney(100)"><i class="el-icon-check"></i>100平台币</div>
                <div :class="{active:money==500 && customRadio != 1}" class="num-item" @click="selMoney(500)"><i class="el-icon-check"></i>500平台币</div>
                <div :class="{active:money==1000 && customRadio != 1}" class="num-item" @click="selMoney(1000)"><i class="el-icon-check"></i>1000平台币</div>
                <div class="charge-money flex">
                    <label>自定义</label>

                    <div class="flex input-box">
                        <input type="text" @keydown="customMoneyChange" @focus="customMoneyFocus" v-model="customMoney" class="chargeinp" />
                        <span class="unit">平台币</span>
                    </div>

                </div>
            </div>
            <div class="charge-in">
                <div>请确认：充值
                    <span>{{amount?amount + '.00' : 0.00}}</span>元，您将获得
                    <span>{{amount?amount:0}}</span>平台币！</div>
            </div>
            <div class="charge-btn">
                <div class="primary-btn" @click="chargeHandle">确认充值</div>
            </div>
        </div>

        <div class="base64Img-box" v-if="maskShow">
            <div class="modal-mask"></div>
            <div class="modal-wrapper">
                <div class="modal-container">
                    <div class="modal-header">
                        <i style="font-size: 14px;" class="iconfont icon-guanbi modal-close" @click="closeMask"></i>
                        <div class="modal-txt">{{this.payway == 'alipay' ? '支付宝支付' : '微信支付'}}</div>
                    </div>
                    <div class="modal-body" style="width: 280px;height: 250px;text-align: center;">
                        <img v-if="!chargesuc" style="display: inline-block;width: 246px;height: 246px;" class="base64Img" :src="base64Img" alt="支付二维码">
                        <img v-if="chargesuc" style="width: 200px;height: 200px;display: inline-block;margin-top: 35px;" src="//oss.51ztx.com//money_suc.gif">
                    </div>
                </div>
            </div>

        </div>

    </div>
</template>
<script>
const qrcode = require('qrcode-js');
export default {
    data() {
        return {
            base64Img: '',
            sn: '',
            maskShow: false,
            status: 0,
            payway: 'alipay',
            money: 50,
            customMoney: '',
            customRadio: 0,
            downkey: '',
            chargesuc:false
        }
    },
    mounted() {

    },
    computed: {
        amount() {
            let ammount = 0;
            if (this.customRadio) {
                ammount = this.customMoney;
            } else {
                ammount = this.money;
            }
            return ammount;
        }
    },
    watch: {
        customRadio(newval, oldval) {

        },
        customMoney: function(newval, oldval) {
            if(newval == 0){
                this.customMoney = '';
                return;
            }
            this.customMoney = newval.replace(/[^0-9]/g,"");

            // if (oldval == "" && newval == 0) {
            //     this.customMoney = '';
            //     return;
            // }
            // if (this.downkey) {
            //     if (isNaN(this.downkey)) {
            //         this.customMoney = this.customMoney.substring(0, this.customMoney.length - 1);
            //         this.downkey = '';
            //     }
            // }
        }
    },
    methods: {
        customMoneyChange(e) {
            this.downkey = e.key;
            // this.key
            // if(isNaN(downkey)){
            //     this.customMoney.splice(this.customMoney.length,1)
            // }
        },
        closeMask(){
            this.maskShow = false;
            clearInterval(this.interval);
        },
        selMoney(val) {
            this.money = val;
            this.customRadio = 0;
            this.customMoney = '';
        },
        selPayway(val) {
            this.payway = val;
        },
        customMoneyFocus(e) {
            this.customRadio = 1;
        },
        chargeHandle() {
            if (this.amount * 1 < 1) {
                this.$alert('充值金额必须大于等于1', ' ', {
                    confirmButtonText: '确定',
                    callback: action => {

                    }
                });
                return;
            }
            if(isNaN(this.amount)){
                this.$alert('充值金额必须是数字', ' ', {
                    confirmButtonText: '确定',
                    callback: action => {

                    }
                });
                return;
            }
            //默认微信支付
            let url = '/wapi/company/getRechargeQR4WXCode?amount=' + this.amount;

            if (this.payway == 'alipay') {
                url = '/wapi/company/getRechargeQR4AliCode?amount=' + this.amount;
            }

            this.chargesuc = false;
            this.axios.get(url).then(res => {
                if (res.success) {
                    this.maskShow = true;
                    this.sn = res.data.sn;
                    this.base64Img = qrcode.toDataURL(res.data.qrCode, 6);
                    this.intervalResult();
                }
            })
        },
        queryPayOrder() {
            this.axios.get('/wapi/company/queryPayOrder?sn=' + this.sn).then(res => {
                this.status = res.data.status;
            })
        },
        intervalResult() {
                this.interval = setInterval(function() {
                if (this.status * 1 === 1) {
                    this.chargesuc = true;
                    setTimeout(()=>{
                        this.maskShow = false;
                        this.$router.push({ path: '/index/finance/index' })
                    },2500);
                    clearInterval(this.interval);
//
                } else {
                    this.queryPayOrder();
                }
            }.bind(this), 1500);
        }
    }
}
</script>
<style scoped lang="less">
@import url('../../assets/less/base.less');
@import "../../assets/css/variable";
.com-model{
    padding: 22px 36px 30px;
    border-radius: 10px;
    .title{
        font-size: 24px;
        color: #333333;
        margin-bottom: 24px;

    }
    .type-item{
        width: 225px;
        height: 70px;
        border-radius: 2px;
        border: 1px solid #E6E6E6;
        margin-right: 20px;
        margin-bottom: 20px;
        font-size: 20px;
        color: #333333;
        cursor: pointer;
        .el-icon-check{
            display: none;
        }
        &.active{
            border: 1px solid #057CF9;
            position: relative;
            .el-icon-check{
                display: block;
                position: absolute;
                left: 0;
                top: 0;
                background: @color-primary;
                color: #fff;
                font-size: 10px;
                line-height: 16px;
                text-align: center;
                width: 16px;
                height: 16px;
                z-index: 100    ;
            }
        }
    }
    .num-item{
        width: 150px;
        height: 42px;
        line-height: 42px;
        text-align: center;
        border-radius: 2px;
        border: 1px solid #E6E6E6;
        font-size: 16px;
        color: #333333;
        margin-right: 20px;
        margin-bottom: 20px;
        .el-icon-check{
            display: none;
        }
        &.active{
            border: 1px solid #057CF9;
            position: relative;
            .el-icon-check{
                display: block;
                position: absolute;
                left: 0;
                top: 0;
                background: @color-primary;
                color: #fff;
                font-size: 10px;
                line-height: 16px;
                text-align: center;
                width: 16px;
                height: 16px;
                z-index: 100    ;
            }
        }
    }
    .charge-money{
        margin-bottom: 20px;
        margin-left: 20px;
        font-size: 16px;
        color: #555555;
        .input-box{
            border-radius: 2px;
            border: 1px solid #555555;
            height: 42px;
            background: transparent;
            margin-left: 11px;
            padding: 0 10px;
            input{
                width: 103px;
                height: 32px;
                border-radius: 2px;
                border: 1px solid #E6E6E6;
                margin-right: 20px;
            }
        }
    }
    .charge-in{
        height: 40px;
        line-height: 40px;
        text-align: center;;
        background: #F7FBFF;
        border-radius: 2px;
        font-size: 16px;
        color: #7CB4EF;
        margin-bottom: 48px;
    }
    .primary-btn{
     width: 200px;
     margin: 0 auto;
    }
}
.chargeboxs {
    line-height: 1;
    width: 100%;
    box-sizing: border-box;
    padding: 0 20px;
    overflow: hidden;
    margin-top: 20px;
    box-shadow: 0 0 7px #cbcbcb;
    .charge-way {
        border-bottom: 1px solid #e5e5e5;
        padding-bottom: 20px;
    }
    .tit {
        color: #666;
        margin: 20px 0;
    }
    .charge-waylist {
        float: left;
        overflow: hidden;
        li {
            position: relative;
            float: left;
            width: 115px;
            height: 35px;
            border-radius: 4px;
            overflow: hidden;
            border: 1px solid #ccc;
            cursor: pointer;
            margin-right: 20px;
            &.active {
                border-color: @blue;
            }
            &:hover {
                border-color: @blue;
            }
            .paygou{
                position: absolute;
                width: 22px;
                height: 22px;
                top: -1px;
                right: -1px;
                z-index: 2;
            }
        }

        img {
            width: 115px;
            height: 35px;
        }
    }
    .charge-nums {}
    .charge-numslist {
        li {
            float: left;
            width: 116px;
            height: 40px;
            border-radius: 5px;
            border: solid 1px #ff6511;
            text-align: center;
            line-height: 40px;
            margin-right: 20px;
            cursor: pointer;
            color: #ff6511;
            &:hover {
                background: #ff6511;
                color: #fff;
            }
            &.active {
                background: #ff6511;
                color: #fff;
            }
        }
    }
    .charge-money {
        float: left;
        label {
            float: left;
            margin: 12px 5px 0 0;
        }
        .chargeinp {
            float: left;
            width: 100px;
            height: 40px;
            border: solid 1px #ccc;
            border-radius: 5px;
            &:focus {
                border-color: #ff6511;
            }
        }
    }
    .charge-in {
        height: 100px;
        div {
            height: 40px;
            line-height: 40px;
            color: #999;
            padding-left: 20px;
            background: #f9f9f9;
            margin-top: 30px;
        }
        span {
            font-size: 16px;
            color: #ff6511;
            margin: 0 2px;
        }
    }
    .chargebtn {
        width: 136px;
        height: 46px;
        border-radius: 23px;
        background-image: linear-gradient(to left, #ff6511, #ffcc00);
        color: #fff;
        font-size: 16px;
        text-align: center;
        line-height: 46px;
        cursor: pointer;
        margin-bottom: 50px;
    }
}

.modal-mask {
    display: table;
    position: fixed;
    z-index: 9000;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    transition: opacity .25s linear;
}

.modal-wrapper {
    display: table-cell;
    position: fixed;
    z-index: 9001;
    top: 50%;
    left: 50%;
    vertical-align: middle;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    transition: all .12s linear;
    .modal-container {
        width: 280px;
        margin: 0 auto;
        padding: 20px 20px;
        background-color: #fff;
        border-radius: 4px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, .4);
    }
    .modal-header {
        position: relative;
        text-align: center;
        color: #666;
        font-size: 20px;
        .modal-close {
            position: absolute;
            top: 0px;
            right: 10px;
            cursor: pointer;
            font-size: 20px;
        }
    }
    .modal-body {
        text-align: center;
    }
}
</style>



// WEBPACK FOOTER //
// recharge.vue?04b0e2e6